var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragmenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261156542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261156541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 17 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.5H0V0.5H15V1.5Z",
    fill: "#B9B9C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 18 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6.5H0V5.5H15V6.5Z",
    fill: "#B9B9C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 19 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.5H0V10.5H15V11.5Z",
    fill: "#B9B9C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragmenu);
export default __webpack_public_path__ + "static/media/dragmenu.d3883fb487eeb754eae4204f0bc0d63d.svg";
export { ForwardRef as ReactComponent };